var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mousemove":_vm.resetCounterInterval}},[_c('idle-dialog',{attrs:{"visible":_vm.visible,"counter":_vm.dialogCounter},on:{"stayLoggedIn":_vm.stayLoggedIn,"doLogOut":_vm.doLogOut}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }